// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import $ from 'jquery';
import { TradingToolViewBase } from '@front/chart/Tools/TradingTools/TradingToolViewBase';
import { Height } from '@front/sharedcomponents/Variables';
import NewNetTraderTemplate from '@front/templates/NewNetTraderTemplate.html';
import { ButtonType } from '@components/webdesktop/elements/Button/ButtonType';
import { SvgIconType } from '@components/webdesktop/elements/SvgIcon/SvgIconType';
import { ApplicationInfo } from '@shared/commons/ApplicationInfo';
import { applicationVersionController } from '@shared/commons/ApplicationVersionController';
import { ExternalLinkType } from '@shared/commons/cache/ExternalLink/Branding/ExternalLinkType';
import { ExternalScreenStorage } from '@shared/commons/cache/ExternalScreenStorage';
import { HotkeysManager } from '@shared/commons/cache/Hotkeys/HotkeysManager';
import { HotkeysGroupTrading, OrderEntryHotkeysEnum, TradingHotkeysEnum } from '@shared/commons/cache/Hotkeys/NamesEventHotkey ';
import { Connection } from '@shared/commons/Connection';
import { ConnectionErrorsEnum } from '@shared/commons/ConnectionEnums';
import { CustomerAccess } from '@shared/commons/CustomerAccess/CustomerAccess';
import { PanelDisplayMode } from '@shared/commons/CustomerAccess/PanelDisplayMode';
import { DataCache } from '@shared/commons/DataCache';
import { ErrorInformationStorage } from '@shared/commons/ErrorInformationStorage';
import { GlobalAnimationFrameHandler } from '@shared/commons/GlobalAnimationFrameHandler';
import { startRecalculateBalancesLoop } from '@shared/commons/GlobalTimerLoop';
import { KeyCode } from '@shared/commons/KeyEventProcessor';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
import { SessionSettings } from '@shared/commons/SessionSettings';
import { SettingsLoggingManager } from '@shared/commons/SettingsLoggingManager';
import { SideBarButtonsHelper } from '@shared/commons/SideBar/SideBarButtonsHelper';
import { BrandingUtils } from '@shared/commons/UtilsClasses/BrandingUtils';
import { EventUtils } from '@shared/commons/UtilsClasses/EventUtils';
import { ExternalLinksObserver } from '@shared/commons/UtilsClasses/Observers/ExternalLinksObserver';
import { WorkSpaceUserKey } from '@shared/commons/UtilsClasses/WorkSpaceUserKey';
import { Resources } from '@shared/localizations/Resources';
import { datePickerDropDownHandler, externalScreenHandler, messageBoxHandler, multiComboBoxPopupMenuHandler, popupErrorHandler } from '@shared/utils/AppHandlers';
import { ConnectionStates } from '@shared/utils/Connections/connection.types';
import { NewContextMenuItemType } from '@shared/utils/ContextMenuUtils';
import { CustomEvent } from '@shared/utils/CustomEvents';
import { MenuIcons } from '@shared/utils/Enums/MenuIcons';
import { MessageBoxType } from '@shared/utils/Interfaces/Screens/MessageBox.types';
import { externalLinkManager } from '@shared/utils/Managers/ExternalLinkManager';
import { WatchlistManager } from '@shared/utils/Managers/WatchlistManager/WatchlistManager';
import { WatchlistSheetsStorageManager } from '@shared/utils/Managers/WatchlistManager/WatchlistSheetsStorageManager';
import { RulesSet } from '@shared/utils/Rules/RulesSet';
import { SoundManager } from '@shared/utils/SoundManager';
import { OperationType } from '@shared/utils/Trading/OperationType';
import { PlacedFrom } from '@shared/utils/Trading/PlacedFrom';
import { TradingLockUtils } from '@shared/utils/TradingLockUtils';
import { ExternalScreen } from './ExternalScreen';
import { MainWindowBase } from './MainWindowBase';
import { NewNetTraderMode } from './NewNetTraderMode';
import { PropertySetupScreen } from './PropertySetupScreen';
import { TerceraAboutScreen } from './TerceraAboutScreen';
import { TerceraBrokerInfoScreen } from './TerceraBrokerInfoScreen';
import { TerceraBrokerMessageScreen } from './TerceraBrokerMessageScreen';
import { TerceraMessageBox } from './TerceraMessageBox';
import { TerceraOnboardingScreen } from './TerceraOnboardingScreen';
import { TerceraTimeoutMessageBox } from './TerceraTimeoutMessageBox';
import { TerceraTradingPassword } from './TerceraTradingPassword';
import { TradingToolsScreen } from './TradingToolsScreen';
import { UserWebStorage, UserWebStorageInstance } from '../../user-web-storage';
import { ControlEvents } from '../elements/Control';
import { TerceraPopupBaloon } from '../elements/TerceraPopupBaloon';
import { TerceraTabStripItem } from '../elements/TerceraTabStrip';
import { TerceraTextBox } from '../elements/TerceraTextBox';
import { LinkedSystem } from '../misc/LinkedSystem';
import { ThemeManager } from '../misc/ThemeManager';
import { Factory } from '../panels/Factory';
import { AppNames, PanelNames } from '../UtilsClasses/FactoryConstants';
import { MainWindowManager } from '../UtilsClasses/MainWindowManager';
import { BOTTOM_WINDOWS_MARGIN, MENU_TOP_OFFSET, SYMBOL_INFO_PANEL_HEIGHT, SYMBOL_INFO_PANEL_WIDTH, TOP_WINDOWS_MARGIN } from '../UtilsClasses/SizeConstants';
import { WDSettingsStorageManager } from '../UtilsClasses/WDSettingsStorageManager';
import { WorkSpaceDBManager } from '../WorkSpace/WorkSpaceDBManager';
import { MAX_WORKSPACE_COUNT, WorkSpaceManager } from '../WorkSpace/WorkSpaceManager';
import { ApplicationPanel } from '../panels/ApplicationPanel';
import { WDSettings } from '../settings/WDGeneralSettings';
import { ContextEvents, contextHandler } from '../ReactControls/Handlers/ContextHandler';
export class NewNetTrader extends MainWindowBase {
    constructor() {
        super(...arguments);
        this.activePanel = null;
        this.onNetTraderModeChange = new CustomEvent();
        this.onDisconnectCalled = new CustomEvent();
        this.terminalMenu = [];
        this.toolsMenu = [];
        this.moreMenu = [];
        this.TimeoutCounterCycle = null;
        this.TimeoutCounterCycleTime = -1;
        this.ExternalScreenStorage = null;
        this.backupDefaultWebHeader = null;
        this.backupDefaultFaviconHref = null;
        this.backupDefaultPageTitle = null;
        this.brandingWebHeader = null;
        this.IsNewNetTrader = true;
        this._extLinksObserver = new ExternalLinksObserver();
        this.prevLogoutReason = null;
        this.netTraderConnectChange = (newState) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            let newMode = this.get('netTraderState');
            switch (newState.connectionState) {
                case ConnectionStates.CONNECTED: {
                    this.prevLogoutReason = null;
                    // TODO. Refactor all this nightmare. So many entry points...
                    const vendor = Connection.vendor;
                    SessionSettings.clear();
                    // App.UserWebStorage.reinit(vendor.getUserSessionId(), this.Controls.loginScreen.get('connectionParams.connectionName'));
                    UserWebStorageInstance.reinit(vendor.GetLogin(), this.Controls.loginScreen.get('connectionParams.connectionName'));
                    const WorkSpaceUser = new WorkSpaceUserKey(vendor.GetLogin(), this.Controls.loginScreen.get('connectionParams.connectionName'));
                    void WorkSpaceDBManager.InitUserStorage(WorkSpaceUser.getKey());
                    void this.set({ connectedStatus: true });
                    break;
                }
                case ConnectionStates.DISCONNECTED: {
                    try {
                        yield this.saveWorkSpaceData();
                    }
                    catch (error) {
                        console.error('Failed to save workspace data before disconnect:', error);
                    }
                    SoundManager.tryPlaySound(SoundManager.SoundKeys.Finish);
                    this.StopTimeoutCounter();
                    this.tryToCloseAllMenus();
                    // Closing of dialog screens.
                    this.closeAllDialogScreens();
                    if (!isNullOrUndefined((_a = MainWindowManager.AsyncCloseObject) === null || _a === void 0 ? void 0 : _a.AsyncClosePromise)) {
                        yield MainWindowManager.AsyncCloseObject.AsyncClosePromise;
                    }
                    TradingLockUtils.ResetBeforeDisconnection();
                    Resources.setNeedForceUpdateLocale();
                    WorkSpaceManager.needRestoreWS = false;
                    WorkSpaceManager.stopSaveLoop();
                    this.cleanUserData();
                    this.StopPingLoop();
                    this.RemoveAllControls();
                    WorkSpaceManager.clearCurrentWorkSpace();
                    DataCache.cleanup();
                    DataCache.OnReintialize.UnSubscribe(NewNetTrader.Reinitialize);
                    UserWebStorage.RestApiNotWork = false;
                    UserWebStorageInstance.clear();
                    LinkedSystem.Clear();
                    this.ExternalScreenStorage.Clear();
                    // ----
                    newMode = NewNetTraderMode.LoginMode;
                    void this.set({ connectedStatus: false });
                    break;
                }
                case ConnectionStates.CONNECTION_LOST:
                    yield WorkSpaceManager.saveWorkSpace();
                    SoundManager.tryPlaySound(SoundManager.SoundKeys.ConnectionLost);
                    WorkSpaceManager.needRestoreWS = true;
                    this.NeedRestoreLockTradingByPassword = true;
                    void this.set({ connectedStatus: false });
                    WorkSpaceManager.stopSaveLoop();
                    DataCache.cleanup();
                    DataCache.OnReintialize.UnSubscribe(NewNetTrader.Reinitialize);
                    UserWebStorage.RestApiNotWork = false;
                    newMode = NewNetTraderMode.WorkMode;
                    Resources.setNeedForceUpdateLocale();
                    this.StopPingLoop();
                    void this.set({ pingText: '...' });
                    void this.reconnect();
                    break;
            }
            void this.set({ netTraderState: newMode });
        });
        this.reconnect = () => __awaiter(this, void 0, void 0, function* () {
            try {
                const connectData = Connection.ConnectResultData.ConnectParams;
                const { connected, tryAgain = false } = yield Connection.connect(connectData, true);
                if (connected) {
                    return;
                }
                if (tryAgain) {
                    setTimeout(this.reconnect, 5000);
                }
            }
            catch (_a) {
                setTimeout(this.reconnect, 5000);
            }
        });
        this.onExternalLinkClicked = (link) => {
            if (link.brandingToolExtResource !== ExternalLinkType.AUTOCHARTIST_IFRAME) {
                void externalScreenHandler.Show(this.ExternalScreenStorage.GetToolData(link.id), link.brandingToolExtResource === ExternalLinkType.NONE);
            }
            else {
                this.openAutochartistIFrame(link);
            }
        };
        this.onClickToUpdateButtonClicked = () => {
            void this.set({ showUpdateScreen: true, isNeedPassiveUpdate: false });
        };
        this.onLaterUpdateButtonClicked = () => {
            void this.set({ showUpdateScreen: false, isHideUpdateNotificationButton: true });
        };
        this.hotkeyProcess = (hotkey, event) => {
            if (this.get('netTraderState') === NewNetTraderMode.LoginMode) {
                return;
            }
            let isCompleted = false;
            const hotkeyActionGroupTrading = HotkeysManager.GetActionByHotkeyForPanel(hotkey, HotkeysGroupTrading);
            if (!TradingLockUtils.TradingLock.tradingLocked) {
                switch (hotkeyActionGroupTrading) {
                    case TradingHotkeysEnum.CloseAllPositionsImmediately:
                        void DataCache.FOrderExecutor.closeAllPositionsPromise(false, PlacedFrom.WEB_OTHER);
                        isCompleted = true;
                        break;
                    case TradingHotkeysEnum.CancelAllOrdersImmediately:
                        void DataCache.FOrderExecutor.cancelAllOrdersPromise(false, PlacedFrom.WEB_OTHER);
                        isCompleted = true;
                        break;
                    case TradingHotkeysEnum.CancelAllOrdersAndCloseAllPositionsImmediately:
                        void DataCache.FOrderExecutor.cancelAllOrdersPromise(false, PlacedFrom.WEB_OTHER);
                        void DataCache.FOrderExecutor.closeAllPositionsPromise(false, PlacedFrom.WEB_OTHER);
                        isCompleted = true;
                        break;
                }
            }
            if (hotkeyActionGroupTrading === TradingHotkeysEnum.OpenReports) {
                isCompleted = this.processHotkeyOpeningReportsPanel();
            }
            if (!isCompleted) {
                const hotkeyActionForPanel = HotkeysManager.GetActionByHotkeyForPanel(hotkey, PanelNames.AdvancedOrderEntry);
                switch (hotkeyActionForPanel) {
                    case OrderEntryHotkeysEnum.OpenBuyOE:
                        this.processHotkeyOpeningOrderEntryPanelBySide(OperationType.Buy);
                        isCompleted = true;
                        break;
                    case OrderEntryHotkeysEnum.OpenSellOE:
                        this.processHotkeyOpeningOrderEntryPanelBySide(OperationType.Sell);
                        isCompleted = true;
                        break;
                }
            }
            if (!isCompleted) {
                if (this.activePanel instanceof ApplicationPanel) {
                    isCompleted = this.activePanel.HotkeyPressed(hotkey, event);
                }
            }
            if (isCompleted) {
                event.preventDefault();
                event.stopPropagation();
            }
        };
    }
    getType() {
        return AppNames.NewNetTrader;
    }
    //
    // Вызывается один раз
    //
    Initialize() {
        // Pens, brushes init except images.
        WatchlistSheetsStorageManager.initialize();
        WDSettingsStorageManager.initialize();
        // this.initToolstripWorkMode();
        this.initWorkSpaceTabStrip(this.Controls.WorkSpacesList);
        this.InitilizeThread();
        TradingLockUtils.TradingLock.TradingLockChanged.Subscribe(this.updateTradingLockState, this);
    }
    static preloadImagesAsyncCallback() {
        TradingToolViewBase.ThemeChanged();
        MainWindowManager.MainWindow.themeChange();
    }
    updateTradingLockState() {
        MainWindowManager.MainWindow.set('tradingLocked', TradingLockUtils.TradingLock.tradingLocked);
    }
    //
    // Вызывается каждый раз после релогина
    //
    static Reinitialize() {
        try {
            const self = MainWindowManager.MainWindow;
            self.addToolsMenuItems();
            self.updateToolstrip();
            NewNetTrader.populateWorkSpaceTabStrip();
            self.Controls.ticketViewer.tryRegisterUpdates();
            SoundManager.tryPlaySound(SoundManager.SoundKeys.Welcome);
            if (!WorkSpaceManager.needRestoreWS) {
                LinkedSystem.Clear();
            }
            DataCache.LoadAccountFollowerService();
            applicationVersionController.updateBuildVersion();
        }
        catch (ex) {
            ErrorInformationStorage.GetException(ex);
        }
    }
    oninit() {
        super.oninit();
        MainWindowManager.Factory = Factory;
        this.onOpenAccountLookupDropDownForm = this.onOpenAccountLookupDropDownForm.bind(this);
        this.setSessionSettings = this.setSessionSettings.bind(this);
        this.onSetLoginScreenSplashImg = this.onSetLoginScreenSplashImg.bind(this);
        this.toggleSidebarCollapse = this.toggleSidebarCollapse.bind(this);
        this.onClosePropertiesScreen = this.onClosePropertiesScreen.bind(this);
        this.onConnectedStatusChange = this.onConnectedStatusChange.bind(this);
        this.onBuildVersionUpdate = this.onBuildVersionUpdate.bind(this);
        contextHandler.subscribe(ContextEvents.OpenAccountLookupDropDownForm, this.onOpenAccountLookupDropDownForm);
        this.on('accountLookupDropDownFormClose', this.onCloseAccountLookupDropDownForm);
        this.on('setLoginScreenSplashImg', this.onSetLoginScreenSplashImg);
        void this.set('maxWorkspaceCount', MAX_WORKSPACE_COUNT);
        $(window).on('resize', this.updateSize.bind(this));
        this.updateSize();
        this.observe('activeControl', this.onActiveControlChanged);
        this.observe('connectedStatus', this.onConnectedStatusChange);
        // TODO. 1 event subscription.
        this.on('maxWorkspaceCountReached', this.onMaxWorkspaceCountReached);
        WorkSpaceManager.WorkspacesLimitReached.Subscribe(this.onMaxWorkspaceCountReached, this);
        this.on('lockTradingClick', this.OnLockTradingClick);
        Connection.onConnectProcessError.Subscribe(this.onConnectProcessError, this);
        SessionSettings.AdditionalCallBacksHandlers.push(this.setSessionSettings);
        SessionSettings.subscribeOnClosePropertiesScreen(this.onClosePropertiesScreen);
    }
    setSessionSettings(properties) {
        void this.set('sessionSettings', properties);
    }
    onConnectProcessError(errContext) {
        if (isNullOrUndefined(errContext)) {
            return;
        }
        switch (errContext.ErrorCode) {
            case ConnectionErrorsEnum.ERROR_MULTI_POLICY:
                if (this.prevLogoutReason !== null && this.prevLogoutReason === errContext.text) {
                    return; // Avoid showing the same message multiple times.
                }
                if (!isNullOrUndefined(messageBoxHandler.Show)) {
                    this.prevLogoutReason = errContext.text;
                    messageBoxHandler.Show(Resources.getResource('panel.EventLog.eventType.disconnect'), Resources.getResource(errContext.text), messageBoxHandler.msgType.Warning, null, null, false, true, '', { okText: Resources.getResource('general.messageBox.ok') }, true);
                }
                break;
            case ConnectionErrorsEnum.MAX_CONCURRENT_CONNECTIONS:
                if (!isNullOrUndefined(messageBoxHandler.Show)) {
                    messageBoxHandler.Show(Resources.getResource('Max. concurrent connections'), Resources.getResource('Max. concurrent connections reason'), messageBoxHandler.msgType.Warning, null, null, false, true, '', { okText: Resources.getResource('general.messageBox.ok') }, true);
                }
                break;
        }
    }
    baseResizibleBTN() {
        const leftPicture = this.Controls.leftPicture;
        const terminal = this.Controls.Terminal;
        const tools = this.Controls.Tools;
        const more = this.Controls.More;
        let leftTerminal = 0;
        let widthTerminal = 0;
        let leftTools = 0;
        let widthTools = 0;
        let leftMore = 0;
        let widthMore = 0;
        let leftPictureData = null;
        if (leftPicture) {
            leftPictureData = leftPicture.get();
        }
        let curerntLeft = 0;
        if (terminal) {
            leftTerminal = leftPictureData ? +leftPictureData.left + (leftPictureData.width || 0) + 5 : 5;
            widthTerminal = terminal.get('text').length * 8 + 10;
            void this.set({
                leftTerminal,
                widthTerminal
            });
            curerntLeft = leftTerminal + widthTerminal;
        }
        if (tools === null || tools === void 0 ? void 0 : tools.get('visible')) {
            leftTools = curerntLeft;
            widthTools = tools.get('text').length * 8 + 10;
            void this.set({
                leftTools,
                widthTools
            });
            curerntLeft += widthTools;
        }
        if (more) {
            leftMore = curerntLeft;
            widthMore = more.get('text').length * 9 + 10;
            void this.set({
                leftMore,
                widthMore
            });
        }
    }
    oncomplete() {
        this.OnResize = new CustomEvent();
        this.ExternalScreenStorage = new ExternalScreenStorage();
        void this.set({ netTraderState: NewNetTraderMode.LoginMode });
        this.observe('netTraderState', this.netTraderStateChange);
        Connection.subscribeOnConnectStateChange(this.netTraderConnectChange);
        Connection.onGetToken.Subscribe(this.onGetToken, this);
        // В этот метод перенести всю инициализацию??
        this.Initialize();
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
        ThemeManager.onThemeChange.Subscribe(this.themeChange, this);
        this.addExternalMenuItem = this.addExternalMenuItem.bind(this);
        this.updateExternalMenuItem = this.updateExternalMenuItem.bind(this);
        this.deleteExternalMenuItem = this.deleteExternalMenuItem.bind(this);
        this.baseResizibleBTN();
        this.createMainMenuActions();
        this._extLinksObserver.subscribeToAdd(this.addExternalMenuItem);
        this._extLinksObserver.subscribeToUpdate(this.updateExternalMenuItem);
        this._extLinksObserver.subscribeToRemove(this.deleteExternalMenuItem);
        this._extLinksObserver.run();
        HotkeysManager.SubscribeEventHotkeys(this.hotkeyProcess);
    }
    updateSize() {
        const $window = $(window);
        // I don't use ractive.set here for quicker reading in future.
        this.width = $window.outerWidth();
        this.height = $window.outerHeight();
        this.updateLeftToolStripWidth();
    }
    netTraderStateChange(newState, oldState, key) {
        this.onNetTraderModeChange.Raise(newState);
        if (newState === NewNetTraderMode.LoginMode) {
            void this.set('isHideUpdateNotificationButton', false);
            void this.set('showUpdateScreen', false);
        }
        this.localize();
    }
    onGetToken() {
        void this.LoadingStarted();
    }
    getClientPanel() {
        return this.Controls.topWindowBody.getClientPanel();
    }
    setToolstripItems(itemsLeft, itemsRight) {
        const leftToolstrip = this.Controls.leftToolStip.Controls.leftToolStip;
        if (leftToolstrip && itemsLeft) {
            leftToolstrip.set('toolStipItems', itemsLeft);
            this.updateToolstrip();
        }
        const rightToolstrip = this.Controls.rigthToolStip.Controls.rigthToolStip;
        if (rightToolstrip && itemsRight) {
            rightToolstrip.set('toolStipItems', itemsRight);
        }
    }
    getAllowedTerminalMenu() {
        const tMenu = [];
        const panelsVisibility = CustomerAccess.GetPanelsVisibility();
        const clickItemTerminal = (item) => {
            Factory.addPanel(item.value);
        };
        if (panelsVisibility[PanelNames.ChartPanel] === true &&
            !Resources.isHidden('ribbon.tradingTerminal.terceraChart')) {
            tMenu.push(this.createTerminalMenuItem('chart', 'panel.terceraChart', MenuIcons.ChartIcon, PanelNames.ChartPanel, clickItemTerminal));
        }
        if (panelsVisibility[PanelNames.TradingViewChartPanel] === true &&
            !Resources.isHidden('ribbon.tradingTerminal.tradingViewChart')) {
            tMenu.push(this.createTerminalMenuItem('tradingViewChart', 'panel.tradingViewChart', MenuIcons.ChartTV, PanelNames.TradingViewChartPanel, clickItemTerminal));
        }
        if (panelsVisibility[PanelNames.InformerPanel] === true &&
            !Resources.isHidden('ribbon.tradingTerminal.watchlist')) {
            tMenu.push(this.createTerminalMenuItem('watchlist', 'panel.watchlist', MenuIcons.WatchListIcon, PanelNames.InformerPanel, clickItemTerminal));
        }
        if (panelsVisibility[PanelNames.MarketDepthPanel] === true &&
            !Resources.isHidden('ribbon.tradingTerminal.level2')) {
            tMenu.push(this.createTerminalMenuItem('marketdepth', 'panel.level2', MenuIcons.MarketDepth, PanelNames.MarketDepthPanel, clickItemTerminal));
        }
        if (panelsVisibility[PanelNames.TimeSalesPanel] === true &&
            !Resources.isHidden('ribbon.tradingTerminal.timeSales')) {
            tMenu.push(this.createTerminalMenuItem('timeandsale', 'panel.timeSales.MenuName', MenuIcons.TimeAndSalesIcon, PanelNames.TimeSalesPanel, clickItemTerminal));
        }
        if (panelsVisibility[PanelNames.GridPanel] === true && !Resources.isHidden('ribbon.tools.grid')) {
            tMenu.push(this.createTerminalMenuItem('grid', 'ribbon.tools.grid', MenuIcons.GridIcon, PanelNames.GridPanel, clickItemTerminal));
        }
        if (!Resources.isHidden('ribbon.tradingTerminal.neworder') || !Resources.isHidden('panel.optionMaster')) {
            tMenu.push({ type: NewContextMenuItemType.Separator });
            if (!Resources.isHidden('ribbon.tradingTerminal.neworder')) {
                tMenu.push(this.createTerminalMenuItem('orderentry', 'panel.neworder', MenuIcons.OrderEntry, PanelNames.AdvancedOrderEntry, clickItemTerminal));
            }
            if (panelsVisibility[PanelNames.OptionMasterPanel] === true && !Resources.isHidden('panel.optionMaster')) {
                tMenu.push(this.createTerminalMenuItem('optionmaster', 'panel.optionMaster', MenuIcons.OptionMaster, PanelNames.OptionMasterPanel, clickItemTerminal));
            }
            tMenu.push({ type: NewContextMenuItemType.Separator });
        }
        if (panelsVisibility[PanelNames.PositionsPanel] === true &&
            !Resources.isHidden('ribbon.tradingTerminal.positions')) {
            tMenu.push(this.createTerminalMenuItem('positions', 'panel.positions', MenuIcons.PositionsIcon, PanelNames.PositionsPanel, clickItemTerminal));
        }
        if (panelsVisibility[PanelNames.OrdersPanel] === true && !Resources.isHidden('ribbon.tradingTerminal.orders')) {
            tMenu.push(this.createTerminalMenuItem('workingorders', 'panel.orders', MenuIcons.WorkingOrder, PanelNames.OrdersPanel, clickItemTerminal));
        }
        if (panelsVisibility[PanelNames.OrderHistoryPanel] === true &&
            !Resources.isHidden('ribbon.tradingTerminal.orderHistory')) {
            tMenu.push(this.createTerminalMenuItem('ordershistory', 'panel.orderHistory', MenuIcons.OrderHistory, PanelNames.OrderHistoryPanel, clickItemTerminal));
        }
        if (panelsVisibility[PanelNames.StatementPanel] === true &&
            !Resources.isHidden('ribbon.tradingTerminal.statement')) {
            tMenu.push(this.createTerminalMenuItem('statement', 'panel.statement', MenuIcons.StatementIcon, PanelNames.StatementPanel, clickItemTerminal));
        }
        if (panelsVisibility[PanelNames.FilledOrdersPanel] === true &&
            !Resources.isHidden('ribbon.tradingTerminal.trades')) {
            tMenu.push(this.createTerminalMenuItem('filledorders', 'panel.trades', MenuIcons.FilledOrder, PanelNames.FilledOrdersPanel, clickItemTerminal));
        }
        if (panelsVisibility[PanelNames.AssetsPanel] === true &&
            !Resources.isHidden('ribbon.tradingTerminal.positions')) {
            tMenu.push(this.createTerminalMenuItem('assets', 'panel.assets', MenuIcons.AssetIcon, PanelNames.AssetsPanel, clickItemTerminal));
        }
        if (panelsVisibility[PanelNames.PositionsBalancePanel] === true &&
            !Resources.isHidden('ribbon.tradingTerminal.positionsBalance')) {
            tMenu.push(this.createTerminalMenuItem('positionsBalance', 'panel.positionsBalance', MenuIcons.PositionBalance, PanelNames.PositionsBalancePanel, clickItemTerminal));
        }
        if (panelsVisibility[PanelNames.SavedOrdersPanel] === true && !Resources.isHidden('panel.savedOrders')) {
            tMenu.push(this.createTerminalMenuItem('savedorders', 'panel.savedOrders', MenuIcons.SavedOrder, PanelNames.SavedOrdersPanel, clickItemTerminal));
        }
        this.terminalMenu = tMenu;
    }
    createTerminalMenuItem(id, text, icon, value, event, isBeta) {
        return {
            type: NewContextMenuItemType.Default,
            id: id,
            text: text,
            icon: icon,
            value: value,
            event: event,
            isBeta: isBeta
        };
    }
    updateToolstrip() {
        const Controls = this.Controls;
        if (!Controls.Terminal || !Controls.More) {
            return;
        }
        this.getAllowedTerminalMenu();
        this.localizeMenuItems();
    }
    getLeftToolStripX() {
        const leftPic = this.Controls.leftPicture;
        if (!leftPic)
            return 0;
        return (leftPic.get('left') || 0) + (leftPic.get('width') || 0) + 10;
    }
    updateLeftToolStripWidth() {
        var _a;
        const Controls = this.Controls;
        if (!((_a = Controls.leftToolStip) === null || _a === void 0 ? void 0 : _a.Controls.leftToolStip)) {
            return;
        }
        const ts = Controls.leftToolStip.Controls.leftToolStip;
        const tsLeft = this.getLeftToolStripX();
        const tsMarginRight = 440;
        // Taken from css class .js-main-top.
        const minWindowW = 1024;
        const windowW = this.width < minWindowW ? minWindowW : this.width;
        let tsW = windowW - tsLeft - tsMarginRight;
        if (tsW < 0)
            tsW = 0;
        ts.set('width', tsW);
    }
    // public restoreToolstripWorkMode = function ()
    // {
    //     // var itemsObj = this.generateToolstripWorkModeItems();
    //     this.setToolstripItems(
    //         itemsObj.itemsLeft,
    //         itemsObj.itemsRight);
    //     // http://tp.pfsoft.lan/entity/56946
    //     var rightToolstrip = this.Controls.rigthToolStip.Controls.rigthToolStip;
    //     rightToolstrip.set('left', 360);
    // };
    disconnectClick() {
        void this.disconnect(false);
    }
    RemoveAllControls() {
        const controls = this.Controls;
        for (const key in controls) {
            const control = controls[key];
            if (control.forceCloseOnLogout) {
                this.removeControl(control);
            }
        }
    }
    disconnect(isNoNActivity) {
        return __awaiter(this, void 0, void 0, function* () {
            if (MainWindowManager.ChangePasswordScreen) {
                MainWindowManager.ChangePasswordScreen.close();
            }
            if (this.Controls.ticketViewer) {
                this.Controls.ticketViewer.ClearQueue();
            }
            Connection.disconnect(isNoNActivity);
            this.onDisconnectCalled.Raise();
        });
    }
    get IsWorkMode() {
        return this.get('netTraderState') === NewNetTraderMode.WorkMode;
    }
    aspAdminDisconnect() {
        void this.set('netTraderState', NewNetTraderMode.LoginMode);
        // this.restoreToolstripWorkMode();
    }
    onChangePassLogout() {
        Connection.disconnect();
        void this.set('netTraderState', NewNetTraderMode.LoginMode);
        this.Controls.loginScreen.loadCredentials();
    }
    // public onDisconnectCancelCallback    (showNextTime)
    // {
    //     SessionSettings.updateWarningOnApplicationClose(showNextTime);
    // };
    localize() {
        var _a;
        if (this.Controls) {
            if (this.Controls.loginScreen) {
                this.Controls.loginScreen.localize();
            }
            if ((_a = this.Controls.accountWidget) === null || _a === void 0 ? void 0 : _a.myAccountDetailsPanel) {
                this.Controls.accountWidget.myAccountDetailsPanel.localize();
            }
        }
        WorkSpaceManager.localize();
        datePickerDropDownHandler.Init();
        multiComboBoxPopupMenuHandler.Init();
        datePickerDropDownHandler.localize();
        void this.set({
            // localkeyAlert: Resources.getResource('screen.Alerts'),
            // localkeyNotifications: Resources.getResource('panel.Notifications'),
            // localkeyVideoWidget: Resources.getResource('panel.VideoWidget'),
            localkeyTerminal: Resources.getResource('ribbon.tradingTerminal'),
            localkeyTools: Resources.getResource('ribbon.tools'),
            localkeyMore: Resources.getResource('ribbon.help.help'),
            clickToUpdateBtnText: Resources.getResource('clickToUpdate.button.text')
            // localkeyHelp: Resources.getResource('ribbon.enviroment.help'),
            // localkeySettings: Resources.getResource('ribbon.enviroment.settings'),
            // localkeyLogout: Resources.getResource('ribbon.enviroment.logout'),
            // localizedSettingsDisabledTT: Resources.getResource('ribbon.enviroment.settings.disabled.tt'),
            // isHelpVisible: !Resources.isHidden("ribbon.enviroment.help")
        });
        this.baseResizibleBTN();
        this.localizeMenuItems();
        const externalMenuItems = this.get('externalMenuItems');
        const localExternalKeys = [];
        const externalMenusLeft = [];
        const externalMenusWidth = [];
        let left = this.Controls.More ? this.get('leftMore') + this.get('widthMore') : 0;
        for (let i = 0; i < externalMenuItems.length; i++) {
            const externalMenuItem = externalMenuItems[i];
            localExternalKeys.push(externalMenuItem.text);
            const w = externalMenuItem.text.length * 7 + 10;
            externalMenusWidth.push(w);
            externalMenusLeft.push(left);
            left += w;
        }
        void this.set({
            externalMenusWidth,
            externalMenusLeft,
            localkeyExternalMenu: localExternalKeys
        });
        if (this.get('connectedStatus')) {
            void this.set({
                connectedStatusText: Resources.getResource('general.connection.status.Connected')
            });
        }
        else {
            void this.set({
                connectedStatusText: Resources.getResource('general.connection.status.Reconnecting')
            });
        }
    }
    localizeMenuItems() {
        this.localizeExternalTools([...this.terminalMenu, ...this.toolsMenu, ...this.moreMenu]);
        const externalMenuItems = this.get('externalMenuItems');
        for (let i = 0; i < externalMenuItems.length; i++) {
            const externalMenuItem = externalMenuItems[i];
            externalMenuItem.text = this.getExternalLinkLocalizedTab(externalMenuItem.value);
            this.localizeExternalTools(externalMenuItem.subitems);
        }
    }
    localizeExternalTools(items) {
        if (!isValidArray(items)) {
            return;
        }
        for (let i = 0; i < items.length; i++) {
            const menuItem = items[i];
            if (menuItem.type !== NewContextMenuItemType.ExternalTool) {
                continue;
            }
            menuItem.text = this.getExternalLinkLocalizedTool(menuItem.value);
            this.localizeExternalTools(menuItem.subitems);
        }
    }
    getExternalLinkLocalizedTab(link) {
        if (isNullOrUndefined(link)) {
            return '';
        }
        const tabName = link.getLocalizedTabNameOrNull();
        if (!isNullOrUndefined(tabName)) {
            return tabName;
        }
        if (!isNullOrUndefined(link.clientTab)) {
            return link.clientTab;
        }
        return this.getExternalLinkLocalizedTool(link);
    }
    getExternalLinkLocalizedTool(link) {
        if (isNullOrUndefined(link)) {
            return '';
        }
        const toolName = link.getLocalizedToolName();
        return toolName;
    }
    themeChange() {
        WorkSpaceManager.themeChange();
        this.ExternalScreenStorage.applyThemeToAllScreens();
        this.setBrandingWebHeader();
    }
    setBrandingWebHeader() {
        const brandingWebHeader = BrandingUtils.GetBrandingWebHeader(ThemeManager.themeValue);
        void this.set('leftPictureUrl', brandingWebHeader);
    }
    // #region WorkSpaceTabStrip
    initWorkSpaceTabStrip(container) {
        this.WorkSpaceTabStrip = container;
        WorkSpaceManager.workSpaceListChanged.Subscribe(NewNetTrader.populateWorkSpaceTabStrip);
        this.WorkSpaceTabStrip.onTabCreate.Subscribe(NewNetTrader.createWorkSpace);
        this.WorkSpaceTabStrip.onTabRemove.Subscribe(NewNetTrader.closeWorkSpace);
        this.WorkSpaceTabStrip.onTabRemovePrepare.Subscribe(NewNetTrader.closeWorkSpaceByBtn);
        this.WorkSpaceTabStrip.onTabChangeAsync = (data) => __awaiter(this, void 0, void 0, function* () {
            yield WorkSpaceManager.changeWorkSpace(data);
        });
        this.WorkSpaceTabStrip.onTabLock.Subscribe(NewNetTrader.changeWorkSpaceLockState);
        this.WorkSpaceTabStrip.onTabStripDoubleClick.Subscribe(NewNetTrader.renameCurrentWorkSpace);
    }
    onMaxWorkspaceCountReached() {
        TerceraMessageBox.Show(Resources.getResource('workspace.information'), Resources.getResource('workspace.numberOfWorkspace'), MessageBoxType.Info, null, null, false, true);
    }
    static populateWorkSpaceTabStrip() {
        // TODO.
        if (!WorkSpaceManager.currentWorkspace) {
            return;
        }
        const wsList = WorkSpaceManager.wsList;
        const fileNames = Object.keys(wsList);
        // fileNames.sort(NewNetTrader.workSpaceCompare);
        const len = fileNames.length;
        const items = [];
        const curWs = WorkSpaceManager.currentWorkspace;
        const curWsFileName = curWs.fileName;
        const curWsLocked = curWs.locked;
        for (let i = 0; i < len; i++) {
            const curFileName = fileNames[i];
            const newItem = new TerceraTabStripItem();
            newItem.text = wsList[curFileName];
            newItem.data = curFileName;
            newItem.locked = curWsFileName === curFileName && curWsLocked;
            newItem.visible = true;
            items.push(newItem);
        }
        MainWindowManager.MainWindow.WorkSpaceTabStrip.set({
            allowUserEdit: !Resources.isHidden('allowWorkspaceEdit') && !ApplicationInfo.isExploreMode,
            allowMoreActionMenu: !Resources.isHidden('allowWorkspaceContextMenu') && !ApplicationInfo.isExploreMode,
            allowCloseTab: !Resources.isHidden('allowWorkspaceCloseFromButton') && !ApplicationInfo.isExploreMode,
            allowAddNewTab: !Resources.isHidden('allowAddWorkspaceFromButton') && !ApplicationInfo.isExploreMode
        });
        MainWindowManager.MainWindow.WorkSpaceTabStrip.set('items', items);
        MainWindowManager.MainWindow.WorkSpaceTabStrip.selectItem(curWsFileName);
    }
    static createWorkSpace() {
        WorkSpaceManager.AddWorkSpace();
    }
    static changeWorkSpaceLockState() {
        const locked = WorkSpaceManager.toggleLock();
        MainWindowManager.MainWindow.WorkSpaceTabStrip.setLockedStateForSelectedItem(locked);
        MainWindowManager.MainWindow.Controls.popupBaloon.show(locked ? TerceraPopupBaloon.States.WorkspaceLocked : TerceraPopupBaloon.States.WorkspaceUnlocked);
        SoundManager.tryPlaySound(locked ? SoundManager.SoundKeys.Lock : SoundManager.SoundKeys.Unlock);
    }
    static closeWorkSpaceByBtn(cb, data) {
        if (NewNetTrader.needToShowCloseWorkSpaceConfirmation(data)) {
            const header = Resources.getResource('workspace.close_wsp');
            NewNetTrader.closeWorkSpaceShowMsg(header, header + ' ' + WorkSpaceManager.wsList[data] + '?', cb);
        }
        else
            cb();
    }
    static closeWorkSpace(data, skipConfirm) {
        if (NewNetTrader.needToShowCloseWorkSpaceConfirmation(data) && !skipConfirm) {
            const header = Resources.getResource('workspace.close_wsp');
            NewNetTrader.closeWorkSpaceShowMsg(header, header + ' ' + WorkSpaceManager.wsList[data] + '?', WorkSpaceManager.closeWorkSpace.bind(WorkSpaceManager, data));
        }
        else
            WorkSpaceManager.closeWorkSpace(data);
    }
    static needToShowCloseWorkSpaceConfirmation(workSpaceName) {
        return WorkSpaceManager.isDirty(workSpaceName);
    }
    static closeWorkSpaceShowMsg(headText, bodyText, callBack) {
        TerceraMessageBox.Show(headText, bodyText, MessageBoxType.Question, callBack, null, false, false, '', {
            cancelText: Resources.getResource('general.messageBox.no'),
            okText: Resources.getResource('general.messageBox.yes')
        });
    }
    static closeCurrentWorkSpace() {
        NewNetTrader.closeWorkSpace(WorkSpaceManager.currentWorkspace.fileName, true);
    }
    static closeAllWorkSpacesButThis() {
        const wsCount = Object.keys(WorkSpaceManager.wsList).length;
        if (wsCount <= 1)
            return;
        TerceraMessageBox.Show(Resources.getResource('workspace.close_wsp'), Resources.getResource('workspace.menu.CloseAllButThis') + '?', MessageBoxType.Question, function () {
            WorkSpaceManager.closeAllWorkSpacesButCurrent();
        });
    }
    static clearCurrentWorkSpace() {
        if (!WorkSpaceManager.canClearCurrentWorkSpace()) {
            return;
        }
        TerceraMessageBox.Show(Resources.getResource('workspace.clear_wsp'), Resources.getResource('workspace.clear_ask'), MessageBoxType.Question, function () {
            WorkSpaceManager.clearAndSaveCurrentWorkSpace();
        });
    }
    static renameCurrentWorkSpace() {
        const ws = WorkSpaceManager.currentWorkspace;
        if (!ws)
            return;
        if (ws.locked) {
            TerceraMessageBox.Show(Resources.getResource('workspace.newWorkspaceName'), Resources.getResource('workspace.At first you should unlock workspace to rename it'), MessageBoxType.Info, null, null, false, true, '');
            return;
        }
        if (ApplicationInfo.isExploreMode) {
            return;
        }
        const tb = new TerceraTextBox();
        const elementParams = MainWindowManager.MainWindow.WorkSpaceTabStrip.getActiveElementSizeParams();
        const posX = elementParams.offset.left;
        const posY = elementParams.offset.top;
        const widthElement = elementParams.width;
        void tb.set({
            left: posX,
            top: posY,
            isPosAbsolute: true,
            width: widthElement,
            text: ws.visibleName,
            elementStyle: 'js-workspace-rename-screen js-input-container'
        });
        MainWindowManager.AddControl(tb);
        tb.setFocus();
        const RenameProcess = (newName) => {
            tb.off(ControlEvents.LostFocus, lf);
            if (newName) {
                NewNetTrader.changeWorkSpaceName(ws.fileName, newName);
            }
            popupErrorHandler.Hide(tb);
            MainWindowManager.MainWindow.removeControl(tb);
            tb.dispose();
        };
        const lf = () => {
            const newName = tb.get('text');
            const getError = WorkSpaceManager.checkText(tb, newName);
            RenameProcess(getError ? '' : newName);
        };
        tb.on(ControlEvents.LostFocus, lf);
        tb.on('keyUp', function (event) {
            const newName = tb.get('text');
            const getError = WorkSpaceManager.checkText(tb, newName);
            // TODO: 'keyCode' is deprecated, need to update
            if (event.original.keyCode === KeyCode.ENTER) {
                if (getError) {
                    RenameProcess('');
                }
                else {
                    RenameProcess(newName);
                }
            }
        });
    }
    static changeWorkSpaceName(wsFileName, newName) {
        if (!WorkSpaceManager.tryChangeWorkSpaceVisibleName(wsFileName, newName)) {
            return;
        }
        void MainWindowManager.MainWindow.WorkSpaceTabStrip.setTabNameByData(wsFileName, newName);
    }
    static cloneCurrentWorkSpace() {
        void WorkSpaceManager.saveWorkSpace().then(function () {
            WorkSpaceManager.cloneCurrentWorkSpace();
        });
    }
    getWorkspaceContextMenu() {
        const ws = WorkSpaceManager.currentWorkspace;
        const locked = ws ? ws.locked : false;
        const result = [];
        if (!Resources.isHidden('workspace.Rename')) {
            result.push({
                type: NewContextMenuItemType.Default,
                text: 'workspace.Rename',
                enabled: !locked,
                event: () => {
                    NewNetTrader.renameCurrentWorkSpace();
                }
            });
        }
        if (!Resources.isHidden('workspace.menu.Clone')) {
            result.push({
                type: NewContextMenuItemType.Default,
                text: 'workspace.menu.Clone',
                event: () => {
                    NewNetTrader.cloneCurrentWorkSpace();
                }
            });
        }
        if (!Resources.isHidden('workspace.menu.Reset')) {
            result.push({
                type: NewContextMenuItemType.Default,
                text: 'workspace.menu.Reset',
                tooltip: 'workspace.menu.Reset.tt',
                event: () => {
                    WorkSpaceManager.resetCurrentWithDefault();
                }
            });
        }
        return result;
    }
    // #endregion
    showGeneralSetting() {
        void PropertySetupScreen.editProperty(SessionSettings, 'screen.properties.title');
        void this.set('isPropertiesScreenOpened', true);
    }
    onClosePropertiesScreen() {
        void this.set('isPropertiesScreenOpened', false);
    }
    addAttachedExternalScreen() {
        return Factory.addPanel(PanelNames.ExternalScreen);
    }
    showAboutScreen() {
        MainWindowManager.AddControl(new TerceraAboutScreen());
    }
    showBrokerInfoScreen() {
        MainWindowManager.AddControl(new TerceraBrokerInfoScreen());
    }
    showOnboardingScreen() {
        TerceraOnboardingScreen.show();
    }
    showHomePage() {
        const url = DataCache.getHomePageUrl();
        if (isValidURL(url)) {
            window.open(url);
        }
    }
    openLiveAccount() {
        window.open(Resources.getResource('ribbon.liveAccount.link'));
    }
    openTradingToolsPanel() {
        TradingToolsScreen.show();
    }
    openAutochartistIFrame(tool) {
        const method = TradingToolsScreen.getAutochartist_iFrameLink;
        const link = method(tool);
        if (!tool || !link) {
            return;
        }
        if (tool.clientUseInternalBrowser) {
            void ExternalScreen.Show({
                Text: link,
                GetRefreshURL: method.bind(null, tool),
                ClientTab: tool.clientTab,
                ScreenName: tool.name,
                Aliases: null,
                ClientUseInternalBrowser: tool.clientUseInternalBrowser,
                Tool: tool
            }, true);
        }
        else {
            window.open(link);
        }
    }
    addTradingToolsMenuItem() {
        // #87660 вставляет в меню More перед сепаратором пункт Trading tools если есть хотя бы одна линка TCRP или ACRP
        if (DataCache.ExternalLinksCache.getTradingCentralExtLink() !== null &&
            DataCache.ExternalLinksCache.getAutochartistExtLink() !== null) {
            return;
        }
        const menu = this.moreMenu;
        const menuItem = this.createTerminalMenuItem('tradingtools', 'ribbon.more.tradingTools', MenuIcons.TradingTools, null, (item) => {
            this.openTradingToolsPanel();
        });
        for (let i = 0; i < menu.length; i++) {
            if (menu[i].type === NewContextMenuItemType.Separator) {
                menu.splice(i, 0, menuItem);
                return;
            }
        }
    }
    addBrokerInfoMenuItem() {
        // #87238 вставляет в меню More перед About вызов экрана BrokerInfo
        if (!DataCache.BrokerInformation) {
            return;
        }
        const menu = this.moreMenu;
        const menuItem = this.createTerminalMenuItem('brokerinfo', 'ribbon.more.brokerInfo', MenuIcons.BrokerInfo, null, (item) => {
            this.showBrokerInfoScreen();
        });
        for (let i = 0; i < menu.length; i++) {
            if (menu[i].id === 'about') {
                menu.splice(i, 0, menuItem);
                return;
            }
        }
    }
    recreateMainMenu() {
        this.createMoreMenu();
        void this.set('externalMenuItems', []);
        this.createToolsMenu();
    }
    navigateToKnowledgeBase() {
        const kbDiv = document.getElementById('kb');
        if (!kbDiv)
            return;
        const kbUrl = kbDiv.dataset.kb;
        if (!kbUrl)
            return;
        const win = window.open(kbUrl, '_blank');
        if (win)
            win.focus();
    }
    InitilizeThread() {
        GlobalAnimationFrameHandler();
        startRecalculateBalancesLoop();
    }
    onContextMenuOpen(event) {
        if (!this.IsWorkMode) {
            return false;
        }
        if (!event.original.path) {
            return false;
        }
        const firstNodeInEventPath = event.original.path[0];
        if (!firstNodeInEventPath || firstNodeInEventPath.className !== 'tab-content') {
            return false;
        }
        // NewNetTrader.showWorkSpaceMenu(event);
        return false;
    }
    loadBrandingRules(brandingKey) {
        return __awaiter(this, void 0, void 0, function* () {
            yield DataCache.GetBrandingRules(brandingKey);
            this.addBrokerInfoMenuItem();
            this.Controls.WorkSpacesList.setPoweredByTextAndLink(DataCache.PoweredByName, DataCache.PoweredByURL);
        });
    }
    LoadingStarted() {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO  84288 84326
            // Подумать над правильным удалением панелей и чистке предыдущих кешей
            const brandingKey = Connection.vendor.loginParams.brandingKey; //  #86122 #85820 #86776 #87660 #87238
            this.recreateMainMenu();
            if (isValidString(brandingKey)) {
                void this.loadBrandingRules(brandingKey);
            }
            const isLoaded = yield DataCache.ProcessLogin(Connection.vendor.GetLogin());
            if (!isLoaded) {
                void this.disconnect(false);
                return;
            }
            const awaitArray = [];
            awaitArray.push(WatchlistSheetsStorageManager.syncInOut());
            awaitArray.push(WDSettingsStorageManager.syncInOut());
            yield Promise.all(awaitArray);
            DataCache.OnReintialize.Subscribe(NewNetTrader.Reinitialize);
            NewNetTrader.Reinitialize();
            ThemeManager.themeChange();
            WatchlistManager.updateStorageItems();
            yield this.set('isSideBarCollapsed', WDSettings.isSideBarCollapsed);
            const result = yield WorkSpaceManager.initWorkspaces();
            const [, /* loaded */ activeName, activeWsLoadingHandler] = result;
            const finishHandler = () => __awaiter(this, void 0, void 0, function* () {
                WorkSpaceManager.getNewCurrentWs(activeName);
                yield WorkSpaceManager.RestoreWorkspaces();
            });
            if (!isNullOrUndefined(activeWsLoadingHandler)) {
                yield activeWsLoadingHandler;
            }
            yield finishHandler();
            this.StartTimeoutCounter(DataCache.getUserSessionTimeout());
            MainWindowManager.MainWindow.set('netTraderState', NewNetTraderMode.WorkMode);
            if (MainWindowManager.MainWindow.NeedRestoreLockTradingByPassword &&
                TradingLockUtils.TradingLock.LockTradingByPassword) {
                MainWindowManager.MainWindow.NeedRestoreLockTradingByPassword = false;
                TradingLockUtils.TradingLock.LockTradingByPassword = false;
                TradingLockUtils.TradingLock.updateTradingLock(false);
            }
            WorkSpaceManager.startSaveLoop();
            MainWindowManager.MainWindow.StartPingLoop();
            WorkSpaceManager.needRestoreWS = false;
            // if (!SessionSettings.OnBoardingWasShown()) {
            //     TerceraOnboardingScreen.show();
            // } else {
            //     TerceraOnboardingScreen.ReleaseSubscription();
            // }
            TerceraBrokerMessageScreen.ShowDelayedMessages();
            MainWindowManager.MainWindow.sendSettingsLoggingSnapshotIfNeed();
        });
    }
    StartPingLoop() {
        const loop = function () {
            Connection.SendPing().then(function (value) {
                MainWindowManager.MainWindow.set({ pingText: value.toFixed(0) + ' ms' });
            });
        };
        loop();
        this.pingInterval = setInterval(loop, 10000);
    }
    StopPingLoop() {
        clearInterval(this.pingInterval);
    }
    ShowSymbolInfo(instrument, account, onCloseCallback) {
        if (isNullOrUndefined(instrument)) {
            return;
        }
        let symbolInfo = this.mySymbolInfo;
        if (isNullOrUndefined(symbolInfo) || (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.torndown) === true) {
            symbolInfo = Factory.addPanel(PanelNames.SymbolInfoPanel, null);
        }
        symbolInfo.symbolLink_In(instrument.GetInteriorID());
        if (!isNullOrUndefined(account)) {
            symbolInfo.set('account', account);
        }
        const newCoord = {
            newX: (window.innerWidth - SYMBOL_INFO_PANEL_WIDTH) / 2,
            newY: (window.innerHeight - SYMBOL_INFO_PANEL_HEIGHT) / 2
        };
        symbolInfo.set({ left: newCoord.newX, top: newCoord.newY });
        const onClose = () => {
            if (!isNullOrUndefined(onCloseCallback)) {
                onCloseCallback();
            }
            symbolInfo.OnClose.UnSubscribe(onClose, this);
        };
        symbolInfo.OnClose.Subscribe(onClose, this);
    }
    ShowOrderEntry(instrument) {
        if (isNullOrUndefined(instrument)) {
            return;
        }
        const orderEntry = Factory.addPanel(PanelNames.AdvancedOrderEntry, null);
        orderEntry.symbolLink_In(instrument.GetInteriorID());
    }
    ShowChart(instrument) {
        if (isNullOrUndefined(instrument)) {
            return;
        }
        const chartPanel = Factory.addPanel(PanelNames.ChartPanel, null);
        chartPanel.symbolLink_In(instrument.GetInteriorID());
    }
    createToolsMenu() {
        this.toolsMenu = [];
        if (this.toolsMenu.length === 0) {
            void this.set('toolsMenuVisible', false);
            this.updateToolstrip();
        }
    }
    createMoreMenu() {
        this.moreMenu = [];
        if (!Resources.isHidden('ribbon.help.home')) {
            this.moreMenu.push(this.createTerminalMenuItem('homepage', 'ribbon.help.home', MenuIcons.HomePage, null, (item) => {
                this.showHomePage();
            }));
        }
        if (!Resources.isHidden('ribbon.help.downloadLogFile')) {
            this.moreMenu.push(this.createTerminalMenuItem('downloadlogfile', 'ribbon.help.downloadLogFile', MenuIcons.DownloadLogFile, null, (item) => {
                EventUtils.saveLogFile();
            }));
        }
        if (Resources.IsResourcePresent('ribbon.more.liveaccount')) {
            this.moreMenu.push(this.createTerminalMenuItem('liveaccount', 'ribbon.more.liveaccount', MenuIcons.LiveAccount, null, (item) => {
                this.openLiveAccount();
            }));
        }
        this.moreMenu.push({ type: NewContextMenuItemType.Separator });
        if (!Resources.isHidden('ribbon.help.onboarding')) {
            this.moreMenu.push(this.createTerminalMenuItem('onboarding', 'ribbon.help.onboarding', MenuIcons.OnboardingIcon, null, (item) => {
                this.showOnboardingScreen();
            }));
        }
        if (!Resources.isHidden('ribbon.help.about')) {
            this.moreMenu.push(this.createTerminalMenuItem('about', 'ribbon.help.about', MenuIcons.AboutIcon, null, (item) => {
                this.showAboutScreen();
            }));
        }
    }
    addExternalMenuItems() {
        const links = DataCache.ExternalLinksCache.getExtLinks();
        let needUpdateToolStrip = false;
        links.forEach((link) => {
            needUpdateToolStrip = this.addExternalMenuItem(link) || needUpdateToolStrip;
        });
        if (needUpdateToolStrip) {
            this.updateToolstrip();
        }
    }
    static insertMenuItemInOrderById(menu, item) {
        // #103169
        if (!menu || !item)
            return;
        for (let i = 0; i < menu.length; i++) {
            const id = menu[i] ? menu[i].id : null;
            if (id && item.id < id) {
                menu.splice(i, 0, item);
                return;
            }
        }
        menu.push(item);
    }
    addExternalMenuItem(link) {
        let needUpdateToolStrip = false;
        if (!link) {
            return needUpdateToolStrip;
        }
        this.ExternalScreenStorage.AddItem(link);
        if (externalLinkManager.isTabLink(link)) {
            const text = this.getExternalLinkLocalizedTool(link);
            const menuItem = this.createTerminalMenuItem(isValidNumber(link.id) ? link.id.toString() : '', text, MenuIcons.ExternalLinkIcon, link, (item) => {
                this.onExternalLinkClicked(item.value);
            });
            menuItem.type = NewContextMenuItemType.ExternalTool;
            if (link.clientTab === 'Tools') {
                NewNetTrader.insertMenuItemInOrderById(this.toolsMenu, menuItem);
                void this.set('toolsMenuVisible', true);
                needUpdateToolStrip = true;
            }
            else if (link.clientTab === 'More' || link.clientTab === 'Help') {
                NewNetTrader.insertMenuItemInOrderById(this.moreMenu, menuItem);
            }
            else if (link.clientTab !== 'Account') {
                const externalMenu = this.get('externalMenuItems');
                const existMenu = externalLinkManager.getExternalMenu(externalMenu, link);
                if (!isNullOrUndefined(existMenu)) {
                    NewNetTrader.insertMenuItemInOrderById(existMenu.subitems, menuItem);
                }
                else {
                    const tabText = this.getExternalLinkLocalizedTab(link);
                    const externalTabItem = this.createTerminalMenuItem(isValidNumber(link.id) ? link.id.toString() : '', tabText, null, link, null, null);
                    externalTabItem.type = NewContextMenuItemType.ExternalTool;
                    externalTabItem.subitems = [menuItem];
                    externalMenu.push(externalTabItem);
                }
                needUpdateToolStrip = true;
                void this.set('externalMenuItems', externalMenu);
            }
            this.localize();
        }
        return needUpdateToolStrip;
    }
    updateExternalMenuItem(link) {
        this.deleteExternalMenuItem(link);
        this.addExternalMenuItem(link);
    }
    deleteExternalMenuItem(link) {
        try {
            this.ExternalScreenStorage.DeleteItem(link);
            for (let i = 0; i < this.toolsMenu.length; i++) {
                if (this.toolsMenu[i].type !== NewContextMenuItemType.ExternalTool || !isValidNumber(link.id)) {
                    continue;
                }
                if (this.toolsMenu[i].id === link.id.toString()) {
                    this.toolsMenu.splice(i, 1);
                    this.updateToolstrip();
                    if (this.toolsMenu.length === 0) {
                        void this.set('toolsMenuVisible', false);
                    }
                    return;
                }
            }
            for (let i = 0; i < this.moreMenu.length; i++) {
                if (this.moreMenu[i].type !== NewContextMenuItemType.ExternalTool || !isValidNumber(link.id)) {
                    continue;
                }
                if (this.moreMenu[i].id === link.id.toString()) {
                    this.moreMenu.splice(i, 1);
                    this.updateToolstrip();
                    return;
                }
            }
            const externalMenu = this.get('externalMenuItems');
            let existMenu = null;
            let jIndex = null;
            for (let j = 0; j < externalMenu.length; j++) {
                if (externalMenu[j].subitems) {
                    const items = externalMenu[j].subitems;
                    for (let q = 0; q < items.length; q++) {
                        if (items[q].id === link.id.toString()) {
                            jIndex = j;
                            existMenu = externalMenu[j];
                        }
                    }
                }
            }
            const container = existMenu ? existMenu.subitems : externalMenu;
            for (let i = 0; i < container.length; i++) {
                if (container[i].id === link.id.toString()) {
                    if (existMenu) {
                        existMenu.subitems.splice(i, 1);
                    }
                    else {
                        externalMenu.splice(i, 1);
                    }
                    if (!container.length && jIndex != null) {
                        externalMenu.splice(jIndex, 1);
                    }
                    void this.set('externalMenuItems', externalMenu);
                    this.updateToolstrip();
                    this.localize();
                    return;
                }
            }
        }
        catch (ex) {
            ErrorInformationStorage.GetException(ex);
        }
    }
    addToolsMenuItems() {
        let atLeastOne = false;
        const clickItemTerminal = (item) => {
            Factory.addPanel(item.value);
        };
        if (CustomerAccess.GetDisplayMode(PanelNames.HighLowPanel) === PanelDisplayMode.Allowed &&
            !Resources.isHidden('panel.HighLowPanel')) {
            this.toolsMenu.push(this.createTerminalMenuItem(PanelNames.HighLowPanel, 'panel.HighLowPanel', MenuIcons.HighLowList, PanelNames.HighLowPanel, clickItemTerminal));
            atLeastOne = true;
        }
        if (CustomerAccess.GetDisplayMode(PanelNames.GainersLosersPanel) === PanelDisplayMode.Allowed &&
            !Resources.isHidden('panel.GainersLosersPanel')) {
            this.toolsMenu.push(this.createTerminalMenuItem(PanelNames.GainersLosersPanel, 'panel.GainersLosersPanel', MenuIcons.GainersLosers, PanelNames.GainersLosersPanel, clickItemTerminal));
            atLeastOne = true;
        }
        if (CustomerAccess.GetDisplayMode(PanelNames.TradingCentral) === PanelDisplayMode.Allowed &&
            !Resources.isHidden('ribbon.tradingTerminal.tradingCentral')) {
            this.toolsMenu.push(this.createTerminalMenuItem('tradingcentral', 'panel.tradingCentral', MenuIcons.TradingCentral, PanelNames.TradingCentral, clickItemTerminal));
            atLeastOne = true;
        }
        if (CustomerAccess.GetDisplayMode(PanelNames.HeatmapPanel) === PanelDisplayMode.Allowed &&
            !Resources.isHidden('panel.HeatmapPanel')) {
            this.toolsMenu.push(this.createTerminalMenuItem('heatmap', 'panel.HeatmapPanel', MenuIcons.HeatMapIcon, PanelNames.HeatmapPanel, clickItemTerminal));
            atLeastOne = true;
        }
        if (CustomerAccess.GetDisplayMode(PanelNames.NewsPanel) === PanelDisplayMode.Allowed &&
            !Resources.isHidden('ribbon.tradingTerminal.news')) {
            this.toolsMenu.push(this.createTerminalMenuItem('news', 'panel.news', MenuIcons.News, PanelNames.NewsPanel, clickItemTerminal));
            atLeastOne = true;
        }
        if (atLeastOne) {
            void this.set('toolsMenuVisible', true);
        }
        this.addExternalMenuItems();
    }
    sendSettingsLoggingSnapshotIfNeed() {
        const sess = SessionSettings;
        if (sess.LogSnapshotHasBeenSent()) {
            return;
        }
        const props = sess.Properties();
        SettingsLoggingManager.LogChange(props, props, true);
    }
    OnLockTradingClick() {
        if (TradingLockUtils.TradingLock.LockTradingByPassword) {
            this.addControl(new TerceraTradingPassword());
        }
        else {
            TradingLockUtils.TradingLock.updateTradingLock(!TradingLockUtils.TradingLock.tradingLocked);
        }
    }
    TimeoutEventsHandler() {
        const w = MainWindowManager.MainWindow;
        if (w.TimeoutCounterCycle) {
            clearTimeout(w.TimeoutCounterCycle);
            if (w.TimeoutCounterCycleTime !== -1) {
                w.TimeoutCounterCycle = setTimeout(w.TimeoutMessage.bind(w), w.TimeoutCounterCycleTime);
            }
        }
    }
    TimeoutMessage() {
        if (WDSettings.disableInactivityPeriod || !Connection.isConnectionCorrect()) {
            this.TimeoutEventsHandler();
            return;
        }
        const scr = TerceraTimeoutMessageBox.Show();
        scr.OK_Handler.then(this.disconnect.bind(this, true));
        scr.NO_Handler.then(this.TimeoutEventsHandler.bind(this));
        this.NonFocusedAttraction();
    }
    StartTimeoutCounter(time) {
        if (time === -1 || isNaN(time) || !time) {
            return;
        }
        document.addEventListener('keydown', this.TimeoutEventsHandler);
        document.addEventListener('mousedown', this.TimeoutEventsHandler);
        this.TimeoutCounterCycleTime = 1000 * 60 * time;
        this.TimeoutCounterCycle = setTimeout(this.TimeoutMessage.bind(this), this.TimeoutCounterCycleTime);
    }
    StopTimeoutCounter() {
        document.removeEventListener('keydown', this.TimeoutEventsHandler);
        document.removeEventListener('mousedown', this.TimeoutEventsHandler);
        this.TimeoutCounterCycleTime = -1;
        if (this.TimeoutCounterCycle) {
            clearTimeout(this.TimeoutCounterCycle);
        }
    }
    NonFocusedAttraction() {
        const title = document.title;
        const symbol = '\u200E';
        const z = () => {
            if (document.hasFocus()) {
                document.title = title;
                if (this.NonFocusedAttractionLoop) {
                    clearInterval(this.NonFocusedAttractionLoop);
                }
                return;
            }
            if (document.title !== symbol) {
                document.title = symbol;
            }
            else {
                document.title = title;
            }
        };
        if (this.NonFocusedAttractionLoop) {
            clearInterval(this.NonFocusedAttractionLoop);
        }
        this.NonFocusedAttractionLoop = setInterval(z.bind(this), 300);
    }
    GetAvaliableHeight() {
        return this.height - TOP_WINDOWS_MARGIN - BOTTOM_WINDOWS_MARGIN;
    }
    GetFirstControlByType(type) {
        var _a;
        // по типу панели или скрина ищет первое вхождение сперва в контролах mainWindow затем в панелях текущего воркспейса, удобно для дебага
        const controls = this.Controls;
        for (const prop in controls) {
            const el = controls[prop];
            if ((el === null || el === void 0 ? void 0 : el.getType) && el.getType() === type) {
                return el;
            }
        }
        const panels = ((_a = WorkSpaceManager === null || WorkSpaceManager === void 0 ? void 0 : WorkSpaceManager.currentWorkspace) === null || _a === void 0 ? void 0 : _a.allPanels)
            ? WorkSpaceManager.currentWorkspace.allPanels
            : null;
        for (const prop in panels) {
            const el = panels[prop];
            if ((el === null || el === void 0 ? void 0 : el.getType) && el.getType() === type) {
                return el;
            }
        }
        return null;
    }
    onOpenAccountLookupDropDownForm(contextProps) {
        void this.set('accountLookupDropDownFormProps', contextProps);
    }
    onCloseAccountLookupDropDownForm() {
        void this.set('accountLookupDropDownFormProps', null);
    }
    onSetLoginScreenSplashImg(ctx, url) {
        void this.set('loginScreenSplashImg', url);
    }
    toggleSidebarCollapse() {
        const isSideBarCollapsed = this.get('isSideBarCollapsed');
        void this.set('isSideBarCollapsed', !isSideBarCollapsed);
        WDSettings.isSideBarCollapsed = !isSideBarCollapsed;
    }
    getPanelSize() {
        return {
            width: this.width,
            height: this.height,
            marginTop: TOP_WINDOWS_MARGIN,
            marginBottom: BOTTOM_WINDOWS_MARGIN
        };
    }
    processHotkeyOpeningOrderEntryPanelBySide(side) {
        var _a;
        (_a = MainWindowManager.Factory) === null || _a === void 0 ? void 0 : _a.addPanel(PanelNames.AdvancedOrderEntry, undefined, function (panel) {
            panel.set('side', side);
        });
    }
    processHotkeyOpeningReportsPanel() {
        var _a;
        if (DataCache.isAllowedForMyUser(RulesSet.FUNCTION_REPORT) && !Resources.isHidden('ribbon.tools.reports')) {
            (_a = MainWindowManager.Factory) === null || _a === void 0 ? void 0 : _a.addPanel(PanelNames.ReportsPanel);
            return true;
        }
        return false;
    }
    saveWorkSpaceData() {
        return __awaiter(this, void 0, void 0, function* () {
            yield WDSettingsStorageManager.syncIn();
            const settingsWait = WDSettingsStorageManager.syncOut();
            const workspaceWait = WorkSpaceManager.synchronizeWorkspacesBeforeExit();
            yield Promise.all([settingsWait, workspaceWait]);
        });
    }
    closeAllDialogScreens() {
        void this.set('accountLookupDropDownFormProps', null);
    }
    cleanUserData() {
        void this.set('sessionSettings', null);
    }
    tryToCloseAllMenus() {
        hideContextMenu();
    }
    createMainMenuActions() {
        const handleOver = (btnContext, menuItems) => {
            const elementRect = btnContext.node.getBoundingClientRect();
            const areaRect = new DOMRect(elementRect.x, elementRect.y, elementRect.width, elementRect.height + MENU_TOP_OFFSET);
            showContextMenu({
                x: areaRect.x,
                y: areaRect.bottom,
                items: menuItems,
                functions: {
                    closeCallback: () => {
                        btnContext.set('focused', false);
                    },
                    onMouseLeave: (event) => {
                        if (!areaRect.contains(event.x, event.y)) {
                            hideContextMenu();
                        }
                    }
                }
            });
            btnContext.set('focused', true);
        };
        this.on('btnOverTerminal', (btnContext) => {
            handleOver(btnContext, this.terminalMenu);
        });
        this.on('btnOverTools', (btnContext) => {
            handleOver(btnContext, this.toolsMenu);
        });
        this.on('btnOverMore', (btnContext) => {
            handleOver(btnContext, this.moreMenu);
        });
        this.on('btnOverExternalMenu', (el, itemIndex) => {
            const externalMenuItems = this.get('externalMenuItems');
            const menuItems = externalMenuItems[itemIndex].subitems;
            handleOver(el, menuItems);
        });
        this.on('ignoreClick', (event) => {
            event.original.preventDefault();
        }); /* 128964 */
    }
    onConnectedStatusChange(connected) {
        if (connected) {
            void this.set({
                connectedStatusText: Resources.getResource('general.connection.status.Connected')
            });
            applicationVersionController.subscribeOnBuildVersionUpdate(this.onBuildVersionUpdate);
            applicationVersionController.startVersionUpdates();
        }
        else {
            void this.set({
                connectedStatusText: Resources.getResource('general.connection.status.Reconnecting')
            });
            applicationVersionController.stopVersionUpdates();
            applicationVersionController.unsubscribeOnBuildVersionUpdate(this.onBuildVersionUpdate);
        }
        SideBarButtonsHelper.OnConnectedStatusChangedEmit(connected);
    }
    onBuildVersionUpdate(version) {
        const oldShowForceUpdateScreen = NewNetTrader.sharedGet('mainContext.showForceUpdateScreen');
        NewNetTrader.sharedSet('mainContext.showForceUpdateScreen', version.forceUpdate || oldShowForceUpdateScreen);
        void this.set({
            isNeedPassiveUpdate: !version.forceUpdate
        });
    }
}
MainWindowBase.extendWith(NewNetTrader, {
    el: '#mainWindow',
    template: NewNetTraderTemplate,
    data: function () {
        return {
            movable: false,
            showHeader: false,
            showFooter: false,
            resizable: false,
            canSelect: false,
            leftPictureUrl: '',
            rightPictureUrl: '',
            netTraderState: 'LM',
            inValue: 0,
            outValue: 0,
            currentTime: '10:57:38',
            currentTimeZoneOffset: '(UTC+02:00)',
            maxWorkspaceCount: 0,
            connectedStatus: false,
            pingText: '...',
            tradingLocked: false,
            externalMenuItems: [],
            externalMenusLeft: [],
            externalMenusWidth: [],
            toolsMenuVisible: false,
            loginScreenSplashImg: '',
            leftTerminal: 0,
            widthTerminal: 0,
            leftTools: 0,
            widthTools: 0,
            leftMore: 0,
            widthMore: 0,
            accountLookupDropDownFormProps: null,
            sessionSettings: null,
            isSideBarCollapsed: false,
            isPropertiesScreenOpened: false,
            isNeedPassiveUpdate: false,
            showUpdateScreen: false,
            isHideUpdateNotificationButton: false,
            clickToUpdateBtnText: '',
            clickToUpdateType: ButtonType.Primary,
            clickToUpdateButtonHeight: Height.SM,
            clickToUpdateIcon: SvgIconType.UpdateNotificationArrow
        };
    }
});
